module.exports = __webpack_public_path__ + "toBride1-we-b-w.0d1c7230.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-b-w.jpg
// module id = puyf
// module chunks = 0